"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowItWorks() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const steps = [{
    number: "01",
    title: "You contact us",
    description: "Schedule a personalized training session at your location."
  }, {
    number: "02",
    title: "We talk and understand your goals",
    description: "Connect with a certified trainer who understands your goals."
  }, {
    number: "03",
    title: "We build a plan around your life",
    description: "Receive a tailored training program designed just for you."
  }, {
    number: "04",
    title: "We train you",
    description: "Monitor your improvements and celebrate your wins."
  }, {
    number: "05",
    title: "You get results!",
    description: "Unlock new training styles and achieve your fitness dreams."
  }];
  return <section id="howitworks" ref={sectionRef} className="relative py-16 md:py-24 px-4 md:px-8 bg-cover bg-center !bg-[url(https://fun-bengal.10web.cloud/wp-content/uploads/2026/05/Gemini_Generated_Image_fawrbfawrbfawrbf.png)]">
      <div className="absolute inset-0 bg-background/80 z-0"></div>
      <div className="max-w-2xl mx-auto relative z-10">
        {}
        <div className="mb-12 md:mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-header font-bold mb-4 transition-opacity duration-700 opacity-100 text-primary" style={{
          fontFamily: "var(--font-header)"
        }}>
            How This Works
          </h2>
          
        </div>

        {}
        <div className="space-y-6 md:space-y-8">
          {steps.map((step, i) => <div key={i} data-index={i} className={`transition-all duration-700 transform ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="relative overflow-hidden bg-card border-2 border-secondary shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300">
                {}
                <div className="absolute top-0 left-0 bg-primary text-primary-foreground px-4 py-2 font-bold text-lg md:text-xl font-header">
                  {step.number}
                </div>

                {}
                <div className="pt-16 px-6 pb-6 md:pt-12">
                  <h3 className="text-xl md:text-2xl font-header font-bold text-foreground mb-3">
                    {step.title}
                  </h3>
                  
                </div>

                {}
                {i < steps.length - 1 && <div className="absolute left-6 -bottom-6 w-0.5 h-6 bg-border md:h-8"></div>}
              </Card>
            </div>)}
        </div>

        {}
        <div className="mt-12 md:mt-16 text-center">
          <Button className="bg-primary text-primary-foreground px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl hover:translate-y-[-4px] transition-all duration-300 font-default" onClick={() => {
          window.location.href = "https://wa.me/6588990728";
        }}>
            Let's go
            <MessageCircle className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>;
}